// Mock data para Banco Agrícola de Venezuela

export const mockUser = {
  id: '1',
  name: 'Carlos Rodríguez',
  email: 'carlos.rodriguez@gmail.com',
  accountNumber: '0166-0234-56-7890123456',
  accountType: 'Cuenta Agrícola Premium',
  balance: 4850950.50,
  availableBalance: 4850950.50,
  currency: 'Bs.'
};

export const mockTransactions = [
  {
    id: '1',
    date: '2025-01-15',
    description: 'Venta de Ganado - Finca El Progreso',
    amount: 580000,
    type: 'ingreso',
    category: 'Ganadería',
    status: 'completada'
  },
  {
    id: '2',
    date: '2025-01-14',
    description: 'Compra de Fertilizantes Agroquímicos',
    amount: -88900,
    type: 'egreso',
    category: 'Insumos Agrícolas',
    status: 'completada'
  },
  {
    id: '3',
    date: '2025-01-12',
    description: 'Pago Cuota Crédito Agrícola',
    amount: -58000,
    type: 'egreso',
    category: 'Préstamos',
    status: 'completada'
  },
  {
    id: '4',
    date: '2025-01-10',
    description: 'Venta de Cosecha de Maíz',
    amount: 338500,
    type: 'ingreso',
    category: 'Agricultura',
    status: 'completada'
  },
  {
    id: '5',
    date: '2025-01-08',
    description: 'Compra de Semillas Certificadas',
    amount: -46400,
    type: 'egreso',
    category: 'Insumos Agrícolas',
    status: 'completada'
  }
];

export const mockLoans = [
  {
    id: '1',
    type: 'Crédito Agrícola',
    amount: 1935000,
    balance: 1354500,
    interestRate: 8.5,
    monthlyPayment: 58000,
    nextPaymentDate: '2025-02-01',
    status: 'activo'
  },
  {
    id: '2',
    type: 'Crédito Ganadero',
    amount: 1161000,
    balance: 464400,
    interestRate: 7.5,
    monthlyPayment: 32890,
    nextPaymentDate: '2025-02-05',
    status: 'activo'
  }
];

export const mockBranches = [
  {
    id: '1',
    name: 'Sucursal Caracas Centro',
    address: 'Av. Urdaneta, Caracas 1010',
    phone: '+58 212-555-0100',
    hours: 'Lun-Vie: 8:00 AM - 4:00 PM'
  },
  {
    id: '2',
    name: 'Sucursal Maracay',
    address: 'Av. Bolívar, Maracay, Aragua',
    phone: '+58 243-555-0200',
    hours: 'Lun-Vie: 8:00 AM - 4:00 PM'
  },
  {
    id: '3',
    name: 'Sucursal Valencia',
    address: 'Av. Cedeño, Valencia, Carabobo',
    phone: '+58 241-555-0300',
    hours: 'Lun-Vie: 8:00 AM - 4:00 PM'
  },
  {
    id: '4',
    name: 'Sucursal Barquisimeto',
    address: 'Carrera 19, Barquisimeto, Lara',
    phone: '+58 251-555-0400',
    hours: 'Lun-Vie: 8:00 AM - 4:00 PM'
  }
];

export const mockTestimonials = [
  {
    id: '1',
    name: 'María González',
    role: 'Agricultora - Yaracuy',
    image: 'https://images.pexels.com/photos/3019836/pexels-photo-3019836.jpeg',
    text: 'Gracias al crédito agrícola pude ampliar mi cultivo de maíz. El proceso fue rápido y el asesoramiento técnico excelente.'
  },
  {
    id: '2',
    name: 'José Pérez',
    role: 'Ganadero - Apure',
    image: 'https://images.unsplash.com/photo-1762437872255-22d922ad10d6',
    text: 'El Banco Agrícola entiende las necesidades del campo. Sus tasas competitivas me permitieron crecer mi finca ganadera.'
  },
  {
    id: '3',
    name: 'Ana Martínez',
    role: 'Productora Avícola - Carabobo',
    image: 'https://images.unsplash.com/photo-1758524051910-60a8d324e110',
    text: 'La plataforma digital es muy fácil de usar. Administro todas mis operaciones desde mi teléfono mientras estoy en la granja.'
  }
];

export const mockServices = [
  {
    id: '1',
    title: 'Créditos Agrícolas',
    description: 'Financiamiento para siembra, cosecha y equipamiento agrícola con tasas preferenciales.',
    icon: 'Sprout'
  },
  {
    id: '2',
    title: 'Créditos Ganaderos',
    description: 'Capital para compra de ganado, ampliación de hatos y mejoras de infraestructura.',
    icon: 'Beef'
  },
  {
    id: '3',
    title: 'Seguros Agrícolas',
    description: 'Protección integral para tus cultivos y ganado ante eventos climáticos adversos.',
    icon: 'Shield'
  },
  {
    id: '4',
    title: 'Asesoría Técnica',
    description: 'Expertos agrónomos te acompañan en la optimización de tu producción.',
    icon: 'Users'
  },
  {
    id: '5',
    title: 'Online Banking',
    description: 'Gestiona tus finanzas desde cualquier lugar con nuestra plataforma digital.',
    icon: 'Smartphone'
  },
  {
    id: '6',
    title: 'Sucursales Físicas',
    description: 'Red de oficinas en todo el país para atención personalizada.',
    icon: 'Building2'
  }
];

export const mockStats = [
  {
    id: '1',
    value: '15,000+',
    label: 'Productores Activos'
  },
  {
    id: '2',
    value: 'Bs. 9.7B+',
    label: 'Financiamiento Otorgado'
  },
  {
    id: '3',
    value: '50+',
    label: 'Sucursales Físicas'
  },
  {
    id: '4',
    value: '98%',
    label: 'Satisfacción del Cliente'
  }
];

export const mockCredentials = {
  username: 'demo',
  password: 'demo123'
};

export const onboardingSteps = [
  {
    step: 1,
    title: 'Información Personal',
    description: 'Proporciona tus datos básicos'
  },
  {
    step: 2,
    title: 'Datos de la Finca',
    description: 'Información sobre tu actividad agrícola'
  },
  {
    step: 3,
    title: 'Documentación',
    description: 'Sube los documentos requeridos'
  },
  {
    step: 4,
    title: 'Confirmación',
    description: 'Revisa y confirma tu solicitud'
  }
];